import { Redirect, Route, Switch, useSearch } from "wouter";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { AgentPage } from "./pages/agents/AgentPage";
import { AgentsListPage } from "./pages/agents/AgentsListPage";
import { CallbackPage } from "./pages/CallbackPage";
import { HomePage } from "./pages/HomePage";
import { NotAllowedPage } from "./pages/NotAllowedPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { CreatePersonaPage } from "./pages/personas/CreatePersonaPage";
import { EditPersonaPage } from "./pages/personas/EditPersonaPage";
import { PersonasListPage } from "./pages/personas/PersonasListPage";
import { SignInPage } from "./pages/SignInPage";

/** The day view moved to the home page; keep old /calendar?date= links working. */
function CalendarRedirect() {
  const search = useSearch();
  return <Redirect to={search ? `/?${search}` : "/"} replace />;
}

/** Every page in the app. Use ProtectedRoute for sign-in only pages. */
export function AppRoutes() {
  return (
    <Switch>
      <Route path="/sign-in" component={SignInPage} />
      <Route path="/callback" component={CallbackPage} />
      <Route path="/not-allowed" component={NotAllowedPage} />

      <ProtectedRoute path="/" component={HomePage} />
      <Route path="/calendar" component={CalendarRedirect} />
      <ProtectedRoute path="/personas" component={PersonasListPage} />
      <ProtectedRoute path="/personas/new" component={CreatePersonaPage} />
      <ProtectedRoute path="/personas/:id" component={EditPersonaPage} />
      <ProtectedRoute path="/agents" component={AgentsListPage} />
      <ProtectedRoute path="/agents/:id" component={AgentPage} />

      <Route component={NotFoundPage} />
    </Switch>
  );
}
